export {locale as meENLang} from './me/en';
export {locale as meESLang} from './me/es';
export {locale as mcsENLang} from './mcs/en';
export {locale as mcsESLang} from './mcs/es';
export {locale as salusENLang} from './salus/en';
export {locale as salusESLang} from './salus/es';
export {locale as pharmpixENLang} from './pharmpix/en';
export {locale as pharmpixESLang} from './pharmpix/es';
